import React, { useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Skeleton } from 'antd';
import McpError from './components/error';

const CardVideo = observer((props) => {
  const {
    data,
    event,
    isAITyping,
  } = props;

  // const mockUrl = 'https://cdnsaas.kuai.360.cn/kjjsaas/adec40cee804614aef43cd805350ec50exp_204144_1p2.mp4';

  const url = useMemo(() => {
    if(data){
      return data;
    }
    if(event.status == "success"){
      try{
        return event.detail.results[0].url;
      } catch(e){}
    }

    return "";
  }, [data, event.status]);

  return (
    <div className="card-video px-24px pt-8px pb-24px size-full flex items-center justify-center">
      {
        isAITyping && event.status == 'running'
        ? <Skeleton active />
        : url
        ? <video className="object-contain max-w-full max-h-500px rounded-12px overflow-hidden" controls preload="metadata" src={url}></video>
        : <McpError />
      }
      
    </div>
  )
});

export default CardVideo;